import { Row } from 'react-table'
import { EntityId, EntityState } from '@reduxjs/toolkit'
import { isNil } from 'lodash/fp'

import { deviceStatuses } from 'features/home/consts'
import { generateUiDeviceOptions } from 'features/home/utils'
import { Devices } from './types'
import { UNUSED_STATUS_CODE } from './consts'
import { UiDeviceStates } from '@racepointenergy/swc/scs/features/host-states'
import ReactDOMServer from 'react-dom/server'
import { IntlProvider } from 'react-intl'

export const parseUiDevicesToDevices = (
  uiDevices: EntityState<UiDeviceStates>
): Devices[] => {
  return uiDevices.ids.map((idDevice) => parseUiDevice(uiDevices, idDevice))
}

export const parseUiDevice = (
  uiDevices: EntityState<UiDeviceStates>,
  idDevice: EntityId
): Devices => {
  return {
    status: uiDevices.entities[idDevice]?.Status?.value,
    id: uiDevices.entities[idDevice]?.id,
    deviceName:
      uiDevices.entities[idDevice]?.Name?.value ||
      uiDevices.entities[idDevice]?.id,
    deviceType: uiDevices.entities[idDevice]?.DeviceType?.value,
    deviceModel: uiDevices.entities[idDevice]?.DeviceModel?.value,
    controller: '-',
    room: uiDevices.entities[idDevice]?.CurrentZone?.value,
    ipAddress: uiDevices.entities[idDevice]?.IPAddress?.value,
    hostname: '-',
    configPlacedZone: '-',
    name: uiDevices.entities[idDevice]?.Name?.value,
    deviceManufacturer: uiDevices.entities[idDevice]?.DeviceMake?.value,
    stats: {
      BytesSent: 0,
      BytesReceived: 0,
    },
  }
}

export const getUniqueDevicesValues = (tableData: Devices[]) => {
  const options: Record<string, string[]> = {
    deviceTypes: [],
    rooms: [],
  }

  if (!tableData.length) return

  tableData.forEach((el) => {
    const deviceType = el.deviceType
    const room = el.room
    if (
      deviceType &&
      !options.deviceTypes.includes(deviceType) &&
      deviceType !== '-'
    ) {
      options.deviceTypes.push(deviceType)
    }
    if (room && !options.rooms.includes(room) && room !== '-') {
      options.rooms.push(room)
    }
  })

  return {
    rooms: generateUiDeviceOptions(options.rooms, 'All Rooms'),
    deviceTypes: generateUiDeviceOptions(options.deviceTypes, 'All Devices'),
    statuses: generateUiDeviceOptions(deviceStatuses, 'Any Status', true),
  }
}

export function sortByStatus(
  rowA: Row<Devices>,
  rowB: Row<Devices>,
  id: string
) {
  const valueA =
    rowA?.values[id] === UNUSED_STATUS_CODE || isNil(rowA?.values[id])
      ? -1
      : rowA?.values[id]
  const valueB =
    rowB?.values[id] === UNUSED_STATUS_CODE || isNil(rowB?.values[id])
      ? -1
      : rowB?.values[id]

  return valueA > valueB ? 1 : -1
}

export const shouldShowDeviceIP = (ipAddress: string | null | undefined) => {
  if (!ipAddress) return false
  return (
    ipAddress?.length > 0 &&
    ipAddress !== '127.0.0.1' &&
    ipAddress !== '0.0.0.0'
  )
}

export const hasNoChildren = (children: React.ReactNode) => {
  // Render a React element to its initial HTML. React will return an HTML string
  // if string length is equal to zero then childrens are not defined or equals to null

  return (
    ReactDOMServer.renderToString(
      <IntlProvider locale="en">{children}</IntlProvider>
    ).length === 0
  )
}
